/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

export type ProductImportStatus = typeof ProductImportStatus[keyof typeof ProductImportStatus];


export const ProductImportStatus = {
  imported: 'imported',
  fused: 'fused',
  already_imported: 'already_imported',
  publication_imported_product_missing: 'publication_imported_product_missing',
  product_dropped: 'product_dropped',
  blocked: 'blocked',
  skipped: 'skipped',
  failed: 'failed',
  unknown_product: 'unknown_product',
} as const;
